import styled from 'styled-components';

// TODO: VerticalListView로 변경 https://gint-team.atlassian.net/browse/PVM-1760
export const OpenMarketProductListSummaryViewGroup = styled.div`
  display: flex;
  padding: 32px var(--radius-large, 16px);
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
`;
